import {
    IUserResponse,
    ISsoLoginUserResponse,
    SsoLoginUserRequestParams
} from '~/types/server.types';
import { BaseSessionAdapter } from '~/services/adapters/base-session.adapter';
import { getForterToken } from '~/utils/forter-load.utils';
import { getTrialDataFromQS } from '~/common/user.utils';

export class SessionAdapter extends BaseSessionAdapter {
    async login({
        email,
        password,
        source,
        sourceData,
        trustThisDevice = true,
        recaptchaToken = null
    }: {
        email: string;
        password: string;
        source?: 'link';
        sourceData?: { linkId: string };
        trustThisDevice?: boolean;
        recaptchaToken?: string;
    }) {
        // TODO: https://honeybook.atlassian.net/browse/NG2REACT-36
        const company_id = window.clientPortalConfiguration?.company_id;
        const f_token = getForterToken();
        const data = {
            password,
            trust_device: trustThisDevice,
            source,
            sourceData,
            company_id,
            f_token,
            email,
            'g-recaptcha-response-v3': recaptchaToken,
            ...getTrialDataFromQS()
        };

        return this.apiService.apiRequest<IUserResponse>({
            method: 'post',
            url: `/api/v2/users/tokens`,
            data,
            networkLabel: 'login'
        });
    }

    proLogoutAsMember() {
        return this.apiService.apiRequest<IUserResponse>({
            method: 'post',
            url: `/api/v2/users/pro/logout`
        });
    }

    getReactVersion() {
        // Api for getting currently deployed react version (git branch)
        return this.apiService.apiRequest({
            method: 'get',
            url: `/react/version`,
            baseURL: '/'
        });
    }

    protected async _loginWithSso({
        data,
        headers
    }: {
        data: SsoLoginUserRequestParams;
        headers: Record<string, string>;
    }) {
        return this.apiService.apiRequest<ISsoLoginUserResponse>({
            method: 'post',
            url: '/api/v2/users/oauth/sso_login_user',
            data,
            headers
        });
    }
}
